export default __webpack_public_path__ + "static/media/009.3d338728.jpg";